import React from 'react';
import Typed from 'typed.js';

interface TypedHeadingProps {
  strings: string[];
  prefix?: string;
}

const TypedHeading: React.FC<TypedHeadingProps> = ({
  strings,
  prefix = '',
}) => {
  const ref = React.useRef(null);

  React.useEffect(() => {
    // You can pass other options here, such as typing speed, back speed, etc.
    // Reference: https://github.com/mattboldt/typed.js/#customization
    const options = {
      strings: strings,
      typeSpeed: 50,
      backSpeed: 100,
      backDelay: 1000,
    };

    // this.el refers to the <span> in the return jsx
    const el = ref.current || '';
    const typed = new Typed(el, options);

    return () => {
      // Makes sure to destroy Typed instance on unmounting
      // to prevent memory leaks
      typed.destroy();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Constructs our children that is then passed down to our
   * React.createElement
   */
  const constructChild = () => (
    <>
      {prefix} <span data-testid="typed" ref={ref} id="typed"></span>
    </>
  );

  return React.createElement(
    'h1',
    { className: 'typed-wrapper' },
    constructChild()
  );
};

export default TypedHeading;
